'use strict';

const cart = require('../cart/cart');
const productQuantityStepper = require('./productQuantityStepper');

let updateMiniCart = true;
const DESKTOP_MEDIA_QUERY = '(min-width: 1025px)';
let minicartSpinnerCleanupBound = false;
let isMinicartRefreshing = false;
let hasPendingMinicartRefresh = false;

/**
 * Ensures minicart quantity updates cannot leave the global loader active.
 */
function bindMinicartSpinnerCleanup() {
	if (minicartSpinnerCleanupBound) {
		return;
	}

	minicartSpinnerCleanupBound = true;

	$(document).on('ajaxComplete.minicartSpinnerCleanup', function (_event, _xhr, settings) {
		const isMinicartQuantityUpdate =
			settings &&
			settings.context &&
			$(settings.context).closest('.minicart').length > 0 &&
			settings.url &&
			settings.url.indexOf('UpdateQuantity') !== -1;

		if (!isMinicartQuantityUpdate) {
			return;
		}

		$.spinner().forceStop();
	});
}

/**
 * @returns {boolean} true when viewport is desktop
 */
function isDesktopViewport() {
	return window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
}

/**
 * @returns {boolean} true on cart or checkout pages where minicart should not open
 */
function isMinicartDisabledPage() {
	const pageAction = $('.page').data('action') || '';
	return (
		pageAction.startsWith('Cart-') || pageAction.startsWith('Checkout-') || $('[data-checkout-leave-cart]').length > 0
	);
}

/**
 * Closes the minicart popover
 */
function closeMinicartPopover() {
	$('.minicart .popover').removeClass('show');
}

/**
 * Updates the minicart quantity badge; clears it when zero so :empty CSS hides it
 * @param {number|string} quantity - item count
 */
function setMinicartQuantity(quantity) {
	const count = parseInt(quantity, 10);
	const $quantity = $('.minicart .minicart-quantity');

	if (!count) {
		$quantity.empty();
	} else {
		$quantity.text(count);
	}
}

/**
 * Hides the badge when external cart updates leave a zero value in the DOM
 */
function normalizeMinicartQuantity() {
	const count = parseInt($('.minicart .minicart-quantity').text(), 10);

	if (!count) {
		$('.minicart .minicart-quantity').empty();
	}
}

/**
 * @returns {boolean} true when minicart popover may open
 */
function canOpenMinicart() {
	if (!isDesktopViewport() || isMinicartDisabledPage()) {
		return false;
	}

	const count = parseInt($('.minicart .minicart-quantity').text(), 10) || 0;
	return count !== 0;
}

/**
 * @returns {boolean} true when minicart content can be shown or refreshed
 */
function isMinicartPopoverOpen() {
	return $('.minicart .popover.show').length > 0;
}

/**
 * @param {Event} event - DOM event
 * @returns {boolean} true when the minicart should stay open during internal async work
 */
function shouldKeepMinicartOpen(event) {
	const relatedTarget = event && event.relatedTarget;
	const target = event && event.target;

	return (
		isMinicartRefreshing ||
		(target && $(target).closest('.lvz-veil').length > 0) ||
		(relatedTarget && $(relatedTarget).closest('.lvz-veil, .minicart').length > 0)
	);
}

/**
 * @param {string|*} uuid - Line item UUID
 * @returns {string}
 */
function normalizeUuid(uuid) {
	return uuid == null ? '' : String(uuid);
}

/**
 * Rejects MiniCartShow HTML that disagrees with optimistic pending qty (both + and -).
 * Without pending entries the HTML is always applied so legitimate server updates are not blocked.
 * @param {JQuery} $content - Parsed incoming minicart HTML
 * @returns {boolean}
 */
function hasStaleQuantities($content) {
	const pendingQuantities = productQuantityStepper.getPendingQuantities();
	const pendingUuids = Object.keys(pendingQuantities);

	if (!pendingUuids.length) {
		return false;
	}

	let hasStaleValue = false;

	$content.find('.quantity').each(function () {
		const uuid = normalizeUuid($(this).data('uuid'));
		const incomingValue = parseInt($(this).val(), 10);

		if (!uuid || isNaN(incomingValue) || !Object.prototype.hasOwnProperty.call(pendingQuantities, uuid)) {
			return;
		}

		if (incomingValue !== pendingQuantities[uuid]) {
			hasStaleValue = true;
			return false;
		}
	});

	return hasStaleValue;
}

/**
 * Clears pending qty entries that match the applied minicart HTML.
 * @param {JQuery} $content - Parsed incoming minicart HTML
 */
function clearMatchedPendingQuantities($content) {
	$content.find('.quantity').each(function () {
		const uuid = $(this).data('uuid');
		const incomingValue = parseInt($(this).val(), 10);
		const pendingValue = productQuantityStepper.getPendingQtyByUuid(uuid);

		if (pendingValue !== null && !isNaN(incomingValue) && pendingValue === incomingValue) {
			productQuantityStepper.clearPendingQtyByUuid(uuid);
		}
	});
}

/**
 * Appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
	let newUrl = url;

	newUrl +=
		(newUrl.indexOf('?') !== -1 ? '&' : '?') +
		Object.keys(params)
			.map(function (key) {
				return key + '=' + encodeURIComponent(params[key]);
			})
			.join('&');

	return newUrl;
}

/**
 * Removes a line item from the basket via the minicart
 * @param {jQuery} $btn - remove button element
 */
function removeLineItemFromMinicart($btn) {
	const productID = $btn.data('pid');
	let url = $btn.data('action');
	const uuid = $btn.data('uuid');
	const urlParams = {
		pid: productID,
		uuid: uuid
	};

	url = appendToUrl(url, urlParams);

	$('body').trigger('cart:beforeUpdate');

	$.ajax({
		lvzSkipAutoSpinner: true,
		url: url,
		type: 'get',
		dataType: 'json',
		success: function (data) {
			const basket = data.basket;

			setMinicartQuantity(basket.numItems);
			$('.minicart .minicart-link').attr({
				'aria-label': basket.resources.minicartCountOfItems,
				title: basket.resources.minicartCountOfItems
			});

			if (basket.items.length === 0) {
				$('.minicart .popover').empty().removeClass('show');
			}

			$('body').trigger('cart:update', data);
		},
		error: function (err) {
			if (err.responseJSON && err.responseJSON.redirectUrl) {
				window.location.href = err.responseJSON.redirectUrl;
			} else if (err.responseJSON && err.responseJSON.errorMessage) {
				$('.minicart-error')
					.empty()
					.append(
						'<div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">' +
							'<span class="icon-info-circle" aria-hidden="true"></span>' +
							'<span class="valid-cart-error__message">' +
							err.responseJSON.errorMessage +
							'</span>' +
							'</div>'
					);
			}
		}
	});
}

/**
 * Refreshes the minicart popover content.
 * Only one request is allowed at a time: refreshes requested while a load is in progress
 * are collapsed into a single follow-up request, keeping the popover open and preserving
 * the product list scroll position after the HTML is replaced.
 */
function loadMinicartContent() {
	const url = $('.minicart').data('action-url');
	const productsScrollTop = $('.minicart .minicart-panel__products').first().scrollTop();

	if (isMinicartRefreshing) {
		hasPendingMinicartRefresh = true;
		return;
	}

	if (productQuantityStepper.isQtyUpdatePending()) {
		hasPendingMinicartRefresh = true;
		return;
	}

	isMinicartRefreshing = true;

	$.ajax({
		lvzSkipAutoSpinner: true,
		url: url,
		method: 'GET'
	}).done(function (data) {
		const currentProductsScrollTop = $('.minicart .minicart-panel__products').first().scrollTop();
		const restoredScrollTop = currentProductsScrollTop || productsScrollTop || 0;
		const $incoming = $('<div>').append($.parseHTML(data || '', document, true));

		if (hasStaleQuantities($incoming)) {
			// Do not tight-loop MiniCartShow here: wait for UpdateQuantity / debounce flush
			// or a refresh already queued while this request was in flight.
			return;
		}

		clearMatchedPendingQuantities($incoming);
		$('.minicart .popover').empty().append($incoming.contents());
		productQuantityStepper.syncAllQtySteppers($('.minicart .popover'));
		$('.minicart .minicart-panel__products').first().scrollTop(restoredScrollTop);
		$('.minicart .popover').addClass('show');
		updateMiniCart = false;
	}).always(function () {
		const shouldRunPendingRefresh =
			hasPendingMinicartRefresh &&
			isMinicartPopoverOpen() &&
			canOpenMinicart() &&
			!productQuantityStepper.isQtyUpdatePending();

		hasPendingMinicartRefresh = false;
		isMinicartRefreshing = false;

		if (shouldRunPendingRefresh) {
			loadMinicartContent();
		} else if (
			productQuantityStepper.isQtyUpdatePending() &&
			isMinicartPopoverOpen() &&
			canOpenMinicart()
		) {
			hasPendingMinicartRefresh = true;
		}
	});
}

module.exports = function () {
	bindMinicartSpinnerCleanup();

	// cart.js (Cart-Show) loads base cart handlers; avoid double-binding from main.js.
	if (!$('.cart-page').length) {
		cart();
	}

	$('.minicart').on('count:update', function (event, count) {
		if (count && $.isNumeric(count.quantityTotal)) {
			setMinicartQuantity(count.quantityTotal);
			$('.minicart .minicart-link').attr({
				'aria-label': count.minicartCountOfItems,
				title: count.minicartCountOfItems
			});
		}
	});

	$('.minicart').on('mouseenter focusin', function () {
		if (!canOpenMinicart()) {
			return;
		}

		if (!updateMiniCart) {
			$('.minicart .popover').addClass('show');
			return;
		}

		loadMinicartContent();
	});

	$('body').on('touchstart click', function (e) {
		if ($('.minicart').has(e.target).length <= 0) {
			if (shouldKeepMinicartOpen(e)) {
				e.stopPropagation();
				return;
			}

			closeMinicartPopover();
		}
	});

	$('.minicart').on('mouseleave focusout', function (event) {
		if (
			event.type === 'mouseleave' ||
			(event.type === 'focusout' && $('.minicart').has(event.target).length > 0) ||
			(event.type === 'mouseleave' && $(event.target).is('.minicart .quantity')) ||
			shouldKeepMinicartOpen(event) ||
			$('body').hasClass('modal-open')
		) {
			event.stopPropagation();
			return;
		}

		closeMinicartPopover();
	});

	$('body').on('change', '.minicart .quantity', function () {
		if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
			window.location.reload();
		}
	});

	$('body').on('product:afterAddToCart', function () {
		updateMiniCart = true;
	});

	$('body').on('click', '.minicart .cart-line-item__remove', function (e) {
		e.preventDefault();
		e.stopPropagation();
		removeLineItemFromMinicart($(this));
	});

	$('body').on('cart:update', function (event, data) {
		updateMiniCart = true;
		normalizeMinicartQuantity();

		if (!(isMinicartPopoverOpen() && canOpenMinicart())) {
			return;
		}

		if (productQuantityStepper.isQtyUpdatePending()) {
			hasPendingMinicartRefresh = true;
			return;
		}

		loadMinicartContent();
	});

	$('body').on('minicart:qtyChangeFlushed', function () {
		if (!hasPendingMinicartRefresh || !(isMinicartPopoverOpen() && canOpenMinicart())) {
			return;
		}

		loadMinicartContent();
	});
};
